import { render, staticRenderFns } from "./printRecipient.vue?vue&type=template&id=4865f6de&scoped=true&"
import script from "./printRecipient.vue?vue&type=script&lang=js&"
export * from "./printRecipient.vue?vue&type=script&lang=js&"
import style0 from "./printRecipient.vue?vue&type=style&index=0&id=4865f6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4865f6de",
  null
  
)

export default component.exports